const unit = (type: string) => {
  type = type ?? '';
  switch (type.toUpperCase()) {
    case 'DS18B20':
    case 'SMT172':
    case 'PT100':
    case 'THERMO-K':
    case 'THERMO-S':
    case 'SHT':
    case 'SHT-TEMP':
    case 'SHT-HARD':
    case 'SHT-TEMP-HARD':
    case 'BMP280':
    case 'BME280':
      return '&degC';
    case 'SHT-HUM':
    case 'SHT-HUM-HARD':
      return '%';
    case 'TDS':
      return 'ppm';
    case 'VOLT':
      return 'v';
    case 'CURRENT':
      return 'A';
    default:
      // State or Ping or others
      return '';
  }
}

export default unit;
